export default "__VITE_ASSET__b10b2293__"